export interface DebtsAccessModel {
  // General access section.
  canReadDebtsById: boolean;
  canReadDebts: boolean;
  canWriteDebts: boolean;
}


export const DEBTS_ACCESS_DEFAULT: DebtsAccessModel = {
  canReadDebtsById: false,
  canReadDebts: false,
  canWriteDebts: false
};
